import { useState, useRef, useMemo, useEffect } from 'react'
import { AgGridReact } from 'ag-grid-react';
import { Col, Input, FormText, Button, FormGroup, Form, Row } from 'reactstrap'
import { useForm } from "../../../../hooks/index";

// Estado inicial para el formulario (se usa en el Hook de useForm)
const detalleBienInmuebleFormFields = {
    finca: '',
    folio: '',
    libro: '',
    departamento: '',
}



const FormGarantiaDetalleBienInmueble = ( props ) => {
    // Custom Hook: Para manejar inputs del formulario
    const { finca, folio, libro, departamento, onInputChange: onInputChange, onResetForm: onResetForm, } = useForm( detalleBienInmuebleFormFields );

    // Se recuperan las props del componente
    const {                         
        idgarantia,
        detalleBienInmueble,
        Swal,
        createDetalleGarantiaBienInmueble,
        listarDetalleBienInmueble,
        deleteUnSoloDetalleBienInmueble
    } = props

    // Hook: para poder filtrar datos de la tabla
    const gridRef = useRef();

    // Hook: Para definir un array que se usara para listar la informacion de la BD
    const [rowData, setRowData] = useState([]);

    // Hook: Para definir un array que se usara para configurar los encabezados de columna
    const [colDefs, setColDefs] = useState([
        // { field: "idgarantia", filter: true },
        { field: "finca", headerName:"Finca", filter: true },
        { field: "folio", headerName: "Folio", filter: true },
        { field: "libro", headerName: "Libro", filter: true },
        { field: "departamento", headerName: "Departamento", filter: true },
        {
            headerName: "Opciones",
            minWidth: 150,
            cellRenderer: (params) => {
                const {idgarantia, iddetallebieninmueble} = params.data
                return(
                    <>
                        <Button tag='p' size='sm' onClick={() => handleButtonDeleteDetalleBienInmueble(idgarantia, iddetallebieninmueble)} color='danger' style={ { marginRight: '0.4vh' } }><i className="fa-solid fa-trash"></i> Eliminar</Button>
                    </>
                    
                )
            }
        },
    ]);

     // Hook: Para distribuir las columnas en toda la tabla
    const autoSizeStrategy = useMemo(() => {
        return {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        };
    }, []);

    // Se settea la información en donde corresponde
    useEffect(() => {
        
        // setColDefs([...headersTable])
        setRowData([...detalleBienInmueble])

    }, [detalleBienInmueble]);

    // Limpia el formulario
    const limpiarDetalleBienInmueble = (idgarantia) => {
        onResetForm() // Limpia campos del formulario
        listarDetalleBienInmueble(idgarantia)
    }

    // Acciona el Insert/Update
    const handleSubmitFormDetalleBienInmueble = (e) => {
        
        e.preventDefault()
        
        // Determina si hay un registro seleccionado para editar o es una inserción
        if(idgarantia > 0){
            if((finca !== '') || (folio !== '') || (libro !== '') || (departamento !== '')){
                const result = createDetalleGarantiaBienInmueble({ idgarantia: idgarantia, finca: finca, folio: folio, libro: libro, departamento: departamento })
                result.then(res => {                
                Swal.fire({
                    icon: 'success',
                    title: res.msg
                })
                                
                limpiarDetalleBienInmueble(idgarantia)
              })
              .catch(e => {
                console.log(e)
                Swal.fire({
                  icon: 'error',
                  title: 'Ocurrio un problema al insertar el detalle',
                  text: 'Comuniquese con matenimiento'
                })
                
                limpiarDetalleBienInmueble(idgarantia)
              })
            }else{
                Swal.fire({
                    icon: 'warning',
                    title: 'Campos vacíos',
                    text: 'Debe ingresar al menos un campo para guardar la información'
                })
            }
            
        }else{
            Swal.fire({
                icon: 'warning',
                title: 'Agregar información del Bien Inmueble',
                text: 'Antes de agregar el detalle, debe agregar información del Bien Inmueble'
            })
        }
        
    }

    // Para eliminar un registro seleccionado de la Tabla
    const handleButtonDeleteDetalleBienInmueble = (idgarantia, iddetallebieninmueble) => {
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                const res = deleteUnSoloDetalleBienInmueble({ iddetallebieninmueble: iddetallebieninmueble })
                res.then(result => {
                    Swal.fire({
                        icon: 'success',
                        title: result.msg
                    })
                    listarDetalleBienInmueble(idgarantia);
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un problema',
                        text: 'Comuniquese con mantenimiento'
                    })
                })
            }
        })
    }

    return (
        <>
            <Form onSubmit={handleSubmitFormDetalleBienInmueble}>
                <Row>
                    <Col md={12}>
                        <FormText>
                            <b>* Datos a Ingresar para Bien Inmueble:</b>
                        </FormText>
                        <div className="border-bottom border-dark"></div>
                        <div className="pt-3"></div>
                    </Col>  
                    <Col md={12}>
                        <FormGroup>
                            <Input 
                                id='idgarantia' 
                                name='idgarantia' 
                                value={ idgarantia } 
                                onChange={ onInputChange } 
                                placeholder='idgarantia' 
                                type='hidden'/>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="finca">Finca:</label>
                            <Input 
                                id='finca' 
                                name='finca' 
                                value={ finca } 
                                onChange={ onInputChange } 
                                placeholder='Finca' 
                                type='text'
                                required/>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="folio">Folio:</label>
                            <Input 
                                id='folio' 
                                name='folio' 
                                value={ folio } 
                                onChange={ onInputChange } 
                                placeholder='Folio' 
                                type='text'
                                required/>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="libro">Libro:</label>
                            <Input 
                                id='libro' 
                                name='libro' 
                                value={ libro } 
                                onChange={ onInputChange } 
                                placeholder='Libro' 
                                type='text'
                                required/>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="departamento">Departamento:</label>
                            <Input 
                                id='departamento' 
                                name='departamento' 
                                value={ departamento } 
                                onChange={ onInputChange } 
                                placeholder='Departamento' 
                                type='text'
                                required/>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <div className="ag-theme-quartz" style={{ height: '30vh', margin: 0 }}>
                            {/* The AG Grid component */}
                            <AgGridReact 
                                ref={gridRef}//PROPIEDAD PARA PERMITIR FILTRAR EN LA TABLA
                                rowData={rowData} 
                                columnDefs={colDefs} 
                                pagination={true}
                                paginationAutoPageSize={true}//PROPIEDAD PARA COLOCAR CANTIDAD DE FILAS QUE PERMITA EL TAMAÑO DE PANTALLA 
                                autoSizeStrategy={autoSizeStrategy}//PROPIEDAD PARA QUE LAS COLUMNAS LLENEN TODA LA TABLA
                            />
                            
                        </div>
                    </Col>
                    <Col md="12">
                        <Button
                            className='btn-round'
                            color='info'
                            type='submit'
                        >
                            <i className="fa-solid fa-square-plus"></i>  Agregar Detalle
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

export {
    FormGarantiaDetalleBienInmueble
}
  